module.exports = __webpack_public_path__ + "asset/image/logo-dbc8.svg";